module.exports = __webpack_public_path__ + "computer.bfeca5b7d7e85c5f71f1.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/davidlagace/Sites/david-lagace-website/src/assets/images/computer.jpg
// module id = ../../../../../src/assets/images/computer.jpg
// module chunks = styles